<template>
  <div class="row mt-4">
    <div class="col-md-4 mb-4" style="height: 141px">
      <div class="dashboardCard h-100 pb-2 px-3 pt-1" v-loading="dataLoading">
        <!-- <div
          class="card-icon d-flex justify-content-between align-items-center mt-3"
        >
          <div class="mb-1">
            <span class="text-success d-flex align-items-center">
              <span>+23%</span>
              <el-icon class="text-success" :size="18"><Top /></el-icon>
            </span>
          </div>
          <div class="icon-one">
            <SketchIcon class="w-16 h-16 text-white" />
          </div>
        </div> -->
        <router-link
          :to="`/tenant/asset/all-assets`"
          class="no-decoration text-dak"
        >
          <div
            class="card-content d-flex flex-column justify-content-between align-items-start pb-2 h-100 mt-3"
          >
            <span class="card-text text-dak text-head">Number of Assets</span>
            <div class="mb-2">
              <div class="card-title m-0 s-32 h2 font-weight-500">
                {{ assetData.length.toLocaleString() || "0" }}
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="col-md-4 mb-4" style="height: 141px">
      <div class="dashboardCard h-100 pb-2 px-3 pt-1" v-loading="dataLoading">
        <!-- <div
          class="card-icon d-flex justify-content-between align-items-center mt-3"
        >
          <div class="mb-1">
            <span class="text-success d-flex align-items-center">
              <span>+23%</span>
              <el-icon class="text-success" :size="18"><Top /></el-icon>
            </span>
          </div>
          <div class="icon-two">
            <CurrCircleDollarIcon class="w-16 h-16 text-white" />
          </div>
        </div> -->
        <div
          class="card-content d-flex flex-column justify-content-between align-items-start pb-2 h-100 mt-3"
        >
          <span class="card-text text-dak text-head">Valuation</span>
          <div class="mb-2">
            <div class="card-title m-0 s-32 h2 font-weight-500">
              {{ totalAssetAmount.toLocaleString() || "0" }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="col-md-4 mb-4">
      <div class="dashboardCard h-100 pb-2 px-3 pt-1" v-loading="dataLoading">
        <div
          class="card-icon d-flex justify-content-between align-items-center mt-3"
        >
          <div class="mb-1">
            <span class="d-flex align-items-center" style="color: #ff5c00">
              <span>+23%</span>
              <el-icon style="color: #ff5c00" :size="18"><Top /></el-icon>
            </span>
          </div>
          <div class="icon-three">
            <GearFineIcon class="w-10 h-10 text-white" />
          </div>
        </div>
        <div class="card-content mt-3">
          <div class="mb-2"></div>
        </div>
      </div>
    </div> -->
    <div class="col-md-4 mb-4" style="height: 141px">
      <div class="dashboardCard h-100 pb-2 px-3 pt-1" v-loading="dataLoading">
        <!-- <div
          class="card-icon d-flex justify-content-between align-items-center mt-3"
        >
          <div class="mb-1">
            <span class="text-success d-flex align-items-center">
              <span>+23%</span>
              <el-icon class="text-success" :size="18"><Top /></el-icon>
            </span>
          </div>
          <div class="icon-four">
            <HandArrowUpIcon class="w-10 h-10 text-white" />
          </div>
        </div> -->
        <div
          class="card-content d-flex justify-content-between align-items-end mt-3 h-100 pb-2"
        >
          <div
            class="card-content d-flex flex-column justify-content-between align-items-start pb-2 h-100 mt-3"
          >
            <router-link
              to="/tenant/asset/assetissues"
              class="card-text text-dak"
            >
              <span class="card-text text-head text-dak cursor-pointer"
                ><u>Issues reported</u></span
              >
            </router-link>
            <div class="card-title m-0 s-32 h2 font-weight-500">
              {{ assetIssuesData.length.toLocaleString() || 0 }}
            </div>
          </div>
          <div
            class="card-content d-flex flex-column justify-content-between align-items-start pb-2 h-100 mt-3"
          >
            <div class="text-right w-100">
              <div class="card-title m-0 s-32 h2 font-weight-500">
                {{ assetsRequestData.length.toLocaleString() || 0 }}
              </div>
            </div>
            <router-link
              to="/tenant/asset/assetrequests"
              class="text-decoration-none"
            >
              <span class="card-text text-dak text-head cursor-pointer"
                ><u>Asset Requests</u></span
              >
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed } from "vue";
// import CurrCircleDollarIcon from "../../../components/icons/CurrCircleDollarIcon.vue";
// import SketchIcon from "../../../components/icons/SketchIcon.vue";
// import HandArrowUpIcon from "../../../components/icons/HandArrowUpIcon.vue";
// import GearFineIcon from "../../../components/icons/GearFineIcon.vue";

const props = defineProps({
  assetData: {
    type: Array,
    required: true,
  },
  assetsRequestData: {
    type: Array,
    required: true,
  },
  assetIssuesData: {
    type: Array,
    required: true,
  },
});
const dataLoading = ref(false);
const totalAssetAmount = computed(() => {
  return props.assetData.reduce((total, asset) => {
    return total + (asset.amount || 0);
  }, 0);
});
</script>

<style scoped>
.card-text {
  /* color: #696565 !important; */
  font-size: 18px;
  font-weight: 500;
}
.dashboardCard {
  border-radius: 15px;
  height: 141px;
  background: #f2f4f7;
}
.icon-one {
  background: #0745af;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  object-fit: contain;
}
.icon-two {
  background: #ff5c00;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  object-fit: contain;
}
.icon-three {
  background: #e10606;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  object-fit: contain;
}
.icon-four {
  background: #05ac34;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  object-fit: contain;
}
</style>
